




































































import { Component, Prop, Watch, Vue } from "vue-property-decorator";
import * as moment from "moment";
import { PostModel, PostsApi, PutPostRequest } from "../../../apis";
@Component({
  components: {},
})
export default class AdminReviewEditAbout extends Vue {
  headerImageHeight = "100%";
  editor = "";
  imageUrl = "";
  titleHeader = "";

  created() {
    if (this.$store.getters.locale === "en") {
      this.editor = this.about.contentEn;
      this.imageUrl = this.about.headerUrlEn;
      this.titleHeader = this.about.subjectEn;
    }
    if (this.$store.getters.locale === "vi") {
      this.editor = this.about.contentVn;
      this.imageUrl = this.about.headerUrlVn;
      this.titleHeader = this.about.subjectVn;
    }
  }

  beforeDestroy() {
    this.$store.commit("SET_ABOUT", {});
  }

  get about() {
    return this.$store.getters.about as PostModel;
  }

  getEditView() {
    this.$router.push({ name: "edit-about", query: {from: "review"} });
  }

  async updateAbout() {
    try {
      this.$util.showLoading();
      await new PostsApi().updatePost({
        id: this.about.id,
        putPostRequest: {
          subjectEn: this.about.subjectEn,
          headerUrlEn: this.about.headerUrlEn,
          headerUrlVn: this.about.headerUrlVn,
          shortDescriptionEn: "",
          subjectVn: this.about.subjectVn,
          shortDescriptionVn: "",
          contentVn: this.about.contentVn,
          contentEn: this.about.contentEn,
          isAbout: true,
          id: this.about.id,
        },
      });
      this.$router.push({ name: "about" });
    } catch (error) {
      this.$util.showError(error);
    } finally {
      this.$util.hideLoading();
    }
  }

  onLoadImageCompleted(event) {
    const headerImageEle = document.getElementById(
      "header-img"
    ) as HTMLImageElement;
    if (headerImageEle) {
      this.headerImageHeight = "" + headerImageEle.height;
      headerImageEle.classList.add("tw-hidden");
    }
  }
}
